(function(){
  jQuery(document).ready(function($){

    /**
     * FORMULAIRE CUSTOM (Bold Options)
     */
    // Attache un accordéon à un titre et une série d'éléments
    var mkBoldOptionsAccordion = function($title, elts){
      if(elts.length && $title){
        $title.on('click', function(e){
          if(e) e.preventDefault();
          for(var $_elt of elts){
            $_elt.slideToggle(350);
          }
          $(this).toggleClass('closed');
        });
        $title.addClass('closed');
        for(var $_elt of elts){
          $_elt.slideUp(0);
        }
      }
    };
    // Création des accordéons pour tous les formulaires
    //BOLD.options.app.on('option_products_loaded', function(data){
      setTimeout(function(){
        $('.bold_option_set').each(function(){
          var $title = null;
          var elts = [];
          $(this).find('.bold_option').each(function(){
            var $elt = $(this);
            if($elt.hasClass('bold_option_displaytext')){
              mkBoldOptionsAccordion($title, elts);
              $title = $elt;
              elts = [];
            }
            else {
              elts.push($elt);
            }
          });
          mkBoldOptionsAccordion($title, elts);
          $(this).addClass('nsm_inited');
        });
        // Ouverture des acordéons en cas d'erreur
        BOLD.options.app.on('validation_failed', function(data){
          $('.bold_option').slideDown(0);
          $('.bold_option_displaytext').removeClass('closed');
        });
      }, 1000);
    //});
  });
})();